import useSettingsStore from './settings';
import useUserStore from './user';
import useRouteStore from './route';
import useMenuStore from './menu';
import apiUser from '@/api/modules/user';
import { resolveRoutePath } from '@/utils';
import storage from '@/utils/storage';
const useFavoritesStore = defineStore(
// 唯一ID
'favorites', () => {
    const settingsStore = useSettingsStore();
    const userStore = useUserStore();
    const routeStore = useRouteStore();
    const menuStore = useMenuStore();
    const list = ref([]);
    function hasChildren(item) {
        let flag = true;
        if (item.children?.every(i => i.meta?.sidebar === false)) {
            flag = false;
        }
        return flag;
    }
    function getSourceList(arr, basePath) {
        const list = [];
        arr.forEach((item) => {
            if (item.meta?.sidebar !== false) {
                if (item.children && hasChildren(item)) {
                    list.push(...getSourceList(item.children, resolveRoutePath(basePath, item.path)));
                }
                else {
                    list.push(item.redirect ?? resolveRoutePath(basePath, item.path));
                }
            }
        });
        return list;
    }
    function getSourceListByMenus(arr) {
        const list = [];
        arr.forEach((item) => {
            if (item.children && item.children.length > 0) {
                list.push(...getSourceListByMenus(item.children));
            }
            else {
                list.push(item.path);
            }
        });
        return list;
    }
    const flatSidebarMenu = computed(() => {
        const list = [];
        if (settingsStore.settings.app.routeBaseOn !== 'filesystem') {
            routeStore.routes.forEach((item) => {
                item.children && list.push(...getSourceList(item.children));
            });
        }
        else {
            menuStore.menus.forEach((item) => {
                list.push(...getSourceListByMenus(item.children));
            });
        }
        return list;
    });
    // 判断路由是否可添加进收藏夹
    function canAdd(fullPath) {
        return flatSidebarMenu.value.includes(fullPath);
    }
    // 判断路由是否已经添加进收藏夹
    function isAdd(fullPath) {
        return list.value.some(item => item.fullPath === fullPath);
    }
    // 新增收藏
    function add(route) {
        const meta = route.matched.at(-1)?.meta;
        if (!list.value.find(item => item.fullPath === route.fullPath)) {
            list.value.push({
                fullPath: route.fullPath,
                title: meta?.title,
                i18n: meta?.i18n,
                icon: meta?.icon ?? meta?.breadcrumbNeste?.findLast(item => item.icon)?.icon,
            });
        }
        updateStorage();
    }
    // 删除收藏
    function remove(fullPath) {
        list.value = list.value.filter((item) => {
            return item.fullPath !== fullPath;
        });
        updateStorage();
    }
    // 拖拽排序
    function sort(newIndex, oldIndex) {
        list.value.splice(newIndex, 0, list.value.splice(oldIndex, 1)[0]);
        updateStorage();
    }
    // 更新 storage 数据
    async function updateStorage() {
        if (settingsStore.settings.favorites.storageTo === 'local') {
            const favoritesData = storage.session.has('favoritesData') ? JSON.parse(storage.session.get('favoritesData')) : {};
            favoritesData[userStore.user.userId] = list.value;
            storage.session.set('favoritesData', JSON.stringify(favoritesData));
        }
        else if (settingsStore.settings.favorites.storageTo === 'server') {
            await apiUser.favoritesEdit(JSON.stringify(list.value));
        }
    }
    // 根据 storage 数据复原当前帐号的标签页
    async function recoveryStorage() {
        if (settingsStore.settings.favorites.storageTo === 'local') {
            if (storage.session.has('favoritesData')) {
                list.value = JSON.parse(storage.session.get('favoritesData'))[userStore.user.userId] || [];
            }
        }
        else if (settingsStore.settings.favorites.storageTo === 'server') {
            const res = await apiUser.favorites();
            list.value = JSON.parse(res.data.favorites || '[]');
        }
    }
    return {
        list,
        canAdd,
        isAdd,
        add,
        remove,
        sort,
        recoveryStorage,
    };
});
export default useFavoritesStore;
